export default {"src":"/_next/static/media/tree-removal.0fc422d7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};